import React from 'react';
import { Box } from '../../../../primitives/Box/Box.es.js';

var NoResults = function NoResults(_ref) {
  var children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(Box, {
      px: "md",
      py: "sm"
    }, children)
  );
};

export { NoResults };